export default "__VITE_ASSET__DSytS9YP__"